<template>
<div class="profile-page container">
    <h1 class="purple">
        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 38.9 38.9">
            <!-- eslint-disable-next-line max-len -->
            <path class="st0" d="M28.8 17.3c-0.4 0-0.7 0.3-0.7 0.7v18.7c0 0.4-0.3 0.7-0.7 0.7H2.2c-0.4 0-0.7-0.3-0.7-0.7v-25.9h7.2c1.2 0 2.2-1 2.2-2.2V1.4h16.6c0.4 0 0.7 0.3 0.7 0.7V3.6c0 0.4 0.3 0.7 0.7 0.7s0.7-0.3 0.7-0.7V2.2c0-1.2-1-2.2-2.2-2.2h-16.6C9.8 0 8.5 0.5 7.8 1.2L1.2 7.8C0.5 8.5 0 9.8 0 10.8v25.9c0 1.2 1 2.2 2.2 2.2H27.4c1.2 0 2.2-1 2.2-2.2V18C29.5 17.6 29.2 17.3 28.8 17.3zM8.9 2.2C9 2.1 9.2 2 9.4 1.9v6.8c0 0.4-0.3 0.7-0.7 0.7H1.9C2 9.2 2.1 9 2.2 8.9L8.9 2.2z"
            />
            <!-- eslint-disable-next-line max-len -->
            <path class="st0" d="M31.5 5.3c-0.3-0.3-0.7-0.3-1 0l-15.8 15.1c-0.1 0.1-0.1 0.2-0.2 0.3l-2.2 5.8c-0.1 0.3 0 0.6 0.2 0.8 0.1 0.1 0.3 0.2 0.5 0.2 0.1 0 0.2 0 0.3-0.1l5.8-2.9c0.1 0 0.1-0.1 0.2-0.1L34.4 9.1c0.3-0.3 0.3-0.7 0-1L31.5 5.3zM18.3 23.2l-4 2 1.5-3.9 15.2-14.5 1.9 1.9L18.3 23.2z"
            />
            <!-- eslint-disable-next-line max-len -->
            <path class="st0" d="M35.3 0.7h-0.3L32.1 3.6 36 7.5l2.9-2.9V4.3C38.9 1.5 36.5 0.7 35.3 0.7zM36 5.5L34.1 3.6l1.4-1.4c0.6 0.1 1.7 0.4 1.9 1.9L36 5.5z"
            />
        </svg>
        עריכת פרופיל
    </h1>

    <div class="profile-form">
        <form>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">שם פרטי</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <p class="control">
                            <input class="input" type="text"
                             v-model="firstname">
                        </p>
                    </div>
                </div>
            </div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">שם משפחה</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <p class="control">
                            <input class="input" type="text"
                             v-model="lastname">
                        </p>
                    </div>
                </div>
            </div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">דואר אלקטרוני</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <p class="control">
                            <input class="input" type="email"
                             v-model="email">
                        </p>
                    </div>
                </div>
            </div>

            <div class="form-btn">
                <button class="yoga-btn-beige" @click.prevent="updateProfile">
                    שמור
                </button>
            </div>
        </form>
    </div>
</div>
</template>

<script>
export default {
  name: `ProfilePage`,
  computed: {
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
    formData() {
      return {
        fullname: `${this.firstname} ${this.lastname}`,
        email: this.email
      };
    }
  },

  data() {
    return {
      firstname: this.$store.getters.firstName,
      lastname: this.$store.getters.lastName,
      email: this.$store.state.user.email
    };
  },

  methods: {
    updateProfile() {
      this.$store.dispatch(`updateProfile`, this.formData);
    }
  }

  //   created() {
  //     if (this.isLoggedIn === 0) {
  //       this.$router.push(`/profile`);
  //     }
  //   },
};
</script>

<style lang="scss">
$purple: #656b85;
$black: #191919;
$white: #ffffff;

.profile-page {
  padding: 20px 0;
  h1 {
    padding-right: 15px;
  }
}

.profile-form {
  max-width: 700px;
  margin-top: 30px;

  .label {
    font-weight: normal;
    color: $purple;
  }

  .control {
    input {
      border: 1px solid lighten($purple, 30%);
      box-shadow: none;
    }
  }

  .form-btn {
    text-align: left;
  }
}

@media screen and (min-width: 1025px) {
  .profile-page {
    h1 {
      padding-right: 0;
    }
  }
}
</style>
